// import scssVars from "../../../../scss/variables.module.scss";

export const buttonCommonStyle = {
    // color: scssVars.mainIconColor,
    // borderColor: scssVars.borderGrey,
    ":hover": {
      // color: scssVars.mainButtonHighlight,
    },
};

export const inputCommonStyle = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "5px",
    height: "36px",
  },
  "& .MuiInputBase-input": {
    padding: "6px 10px",
  },
};